import {
  useCreateZone,
  useDeleteZone,
  useZones,
} from '@/features/reservation-setup/hooks/useReservationSetup';
import { useT } from '@/i18n';
import {
  Block,
  BlockFooter,
  Button,
  List,
  ListItem,
  Navbar,
  NavRight,
  Link as F7Link,
  Page,
  Preloader,
  f7,
} from 'framework7-react';

function ZonesPage() {
  const t = useT();
  const rs = t.reservationSetup;
  const { data: zones, isLoading, error } = useZones();
  const createZone = useCreateZone();
  const deleteZone = useDeleteZone();

  const handleAdd = () => {
    f7.dialog.prompt(rs.zoneNamePrompt, rs.newZone, (label) => {
      const trimmed = label.trim();
      if (!trimmed) return;
      createZone.mutate(
        { label: trimmed, sortOrder: 0 },
        {
          onError: (e) => f7.dialog.alert(e instanceof Error ? e.message : rs.failedCreateZone),
        },
      );
    });
  };

  const handleDelete = (zoneId: string, label: string) => {
    f7.dialog.confirm(rs.deleteZoneConfirm(label), rs.deleteZone, () => {
      deleteZone.mutate(
        { zoneId },
        {
          onError: (e) => f7.dialog.alert(e instanceof Error ? e.message : rs.failedDeleteZone),
        },
      );
    });
  };

  return (
    <Page name="zones">
      <Navbar title={rs.zones} backLink={t.back}>
        <NavRight>
          <F7Link iconF7="plus" onClick={handleAdd} />
        </NavRight>
      </Navbar>

      {isLoading && (
        <Block className="text-align-center">
          <Preloader />
        </Block>
      )}
      {error && <Block className="text-color-red">{(error as Error).message}</Block>}

      {zones && zones.length === 0 && (
        <Block strongIos strongMd outlineIos className="text-align-center">
          {rs.noZonesYet}
          <p>
            <Button fill round onClick={handleAdd}>
              {rs.addAZone}
            </Button>
          </p>
        </Block>
      )}

      {zones && zones.length > 0 && (
        <List strongIos strongMd outlineIos dividersIos dividersMd>
          {zones.map((z) => (
            <ListItem key={z.id} title={z.label}>
              <i slot="media" className="f7-icons">
                rectangle_3_offgrid
              </i>
              <F7Link
                slot="after"
                iconF7="trash"
                color="red"
                onClick={() => handleDelete(z.id, z.label)}
              />
            </ListItem>
          ))}
        </List>
      )}
      <BlockFooter>{rs.zonesFooter}</BlockFooter>
    </Page>
  );
}

export default ZonesPage;
